import React, { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { Progress } from 'antd'
import styles from './ScoreCard.styles.scss'

interface Parameter {
  parameter: string
  html: React.ReactNode
  key?: string
}

interface ScoreCardProps {
  title: string | ReactNode
  subTitle: string
  parameters: Parameter[]
  value: number
  escalationLabel?: string
  scoreColor?: string
  children?: ReactNode
  withEscalationLabel?: boolean
  isRiskCard?: boolean
}

const ScoreCard = ({
  title,
  subTitle,
  parameters,
  value,
  escalationLabel,
  scoreColor,
  children,
  withEscalationLabel,
  isRiskCard = false,
}: ScoreCardProps) => {
  const progressColor = isRiskCard ? '#FF3B30' : '#2257C5'

  const segmentValue = 25
  const numSegments = 4
  const segments = []

  for (let i = 0; i < numSegments; i++) {
    const segmentStart = i * segmentValue
    const segmentEnd = (i + 1) * segmentValue
    const segmentProgress = Math.min(Math.max((value - segmentStart) / segmentValue, 0), 1)

    segments.push({
      key: i,
      percent: segmentProgress * 100,
      strokeColor: segmentProgress > 0 ? progressColor : undefined,
    })
  }

  return (
    <Box className={styles.box}>
      <Box className={styles.header}>
        <Box className={styles.headerLeft}>
          <h3 className={styles.title}>{subTitle}</h3>
          {isRiskCard && <span className={styles.percentageValue}>({value}%)</span>}
        </Box>
        <Box className={styles.headerRight}>
          <span className={styles.label}>{escalationLabel}</span>
          <Box className={styles.segmentedProgressBar}>
            {segments.map(segment => (
              <Progress
                key={segment.key}
                percent={segment.percent}
                strokeColor={segment.strokeColor}
                trailColor='#DADBDF'
                showInfo={false}
                strokeLinecap='square'
              />
            ))}
          </Box>
        </Box>
      </Box>

      <Box className={styles.parametersSection}>
        {children || null}
        <ul className={styles.parameters}>
          {parameters.map(
            (param, index) =>
              param.html && (
                <li key={index}>
                  {param.parameter && <div className={styles.parameterLabel}>{param.parameter}</div>}
                  <div
                    className={styles.parameterValue}
                    style={param.key === 'taxProductsContainer' ? { width: '100%' } : {}}
                  >
                    {param.html}
                  </div>
                </li>
              ),
          )}
        </ul>
      </Box>
    </Box>
  )
}

export default ScoreCard
